// flow

import React from 'react';
import { withTheme } from 'styled-components';
import FlatButton from 'material-ui/FlatButton';

type Direction = 'left' | 'right';

type Props = {
  direction: Direction,
  style: ?Object,
  onClick: () => void,
  disabled: boolean;
}

function DirectionButton({ direction, style, onClick, disabled }: Props) {
  const text = 'keyboard_arrow_' + direction;

  return (<FlatButton
    icon={<i className="material-icons">{text}</i>}
    style={style}
    onClick={onClick}
    disabled={disabled}
  />);
}

export default withTheme(DirectionButton);



// WEBPACK FOOTER //
// ./src/common/components/DirectionButton.js